import React from 'react';
import { Route, Redirect } from "react-router-dom";
import Footer from './../mobioastro/components/footer/footer'

const PrivateRoute = ({ component: Component, ...rest }) => {

    let isLoggedIn = false;
    let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));

    if (sessionStorage.getItem('loggedIn')) {
        isLoggedIn = JSON.parse(sessionStorage.getItem('loggedIn')).loggedIn;
    }
    return (
        <div>
            <Route
            
                {...rest}
                render={props =>
                    isLoggedIn === true ? (
                        <Component {...props} />
                    ) : (
                            <Redirect to={{ pathname: '/login', state: { from: props.location } }} />

                        )
                }
            />
            { (countryCode.countryCode === 'no')
                ? <Footer country={countryCode.countryCode} />
                : null
            } 
        </div>)
};
export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/utils/privateroute.js